import React, { useContext, useState, useEffect } from "react";
import MainLayout from "../components/Layout/MainLayout";
import { UserContext } from "../contexts/UserContext";
import { typography, profile } from "../styles/theme";
import UpdateModal from "../components/UpdateModal";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Profile = () => {
  const { user } = useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const [updateType, setUpdateType] = useState(""); // "token" or "password"
  const [currentToken, setCurrentToken] = useState("");

  const [showToken, setShowToken] = useState(false); // add this at the top

  useEffect(() => {
    if (user && user.basespace_token) {
      setCurrentToken(user.basespace_token);
    }
  }, [user]);

  const openModal = (type) => {
    setUpdateType(type);
    setShowModal(true);
  };

  const handleUpdate = async (values) => {
    try {
      if (updateType === "token") {
        const { data } = await axios.post(`${API_BASE_URL}/api/users/update-token`, {
          userId: user.id,
          newToken: values.newToken,
        });

        if (data.success) {
          setCurrentToken(values.newToken);
          // Return success object for the modal
          return { success: true, message: data.message || "BaseSpace token updated successfully!" };
        } else {
          // Return error object for the modal
          return { success: false, message: data.message || "Failed to update token" };
        }
      } else if (updateType === "password") {
        if (values.newPassword !== values.confirmPassword) {
          return { success: false, message: "New password and confirmation do not match" };
        }

        const { data } = await axios.post(`${API_BASE_URL}/api/users/update-password`, {
          userId: user.id,
          currentPassword: values.currentPassword,
          newPassword: values.newPassword,
        });

        if (data.success) {
          return { success: true, message: data.message || "Password updated successfully!" };
        } else {
          return { success: false, message: data.message || "Failed to update password" };
        }
      }
    } catch (err) {
      console.error("Update failed:", err);
      // Return error object from catch
      return { 
        success: false, 
        message: err.response?.data?.message || "Update failed, please try again" 
      };
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  // define modal fields dynamically
  const modalFields =
    updateType === "token"
      ? [{ name: "newToken", label: "New BaseSpace Token", type: "text", placeholder: currentToken }]
      : [
          { name: "currentPassword", label: "Current Password", type: "password" },
          { name: "newPassword", label: "New Password", type: "password" },
          { name: "confirmPassword", label: "Confirm New Password", type: "password" },
        ];

  return (
    <MainLayout>
      <h2 style={typography.h2}>Profile</h2>
      {user ? (
        <div style={profile.container}>
          <div style={profile.card}>
            <p style={{ ...typography.body, ...profile.item }}>
              <span style={typography.label}>Username:</span> {user.username}
            </p>
            <p style={{ ...typography.body, ...profile.item }}>
              <span style={typography.label}>Email:</span> {user.email}
            </p>
            <p style={{ ...typography.body, ...profile.item }}>
              <span style={typography.label}>User ID:</span> {user.id}
            </p>
            {/* <p style={{ ...typography.body, ...profile.item }}>
              <span style={typography.label}>BaseSpace Token:</span> {currentToken || "Not set"}
            </p> */}

            <p style={{ ...typography.body, ...profile.item }}>
              <span style={typography.label}>BaseSpace Token:</span>{" "}
              {showToken ? currentToken || "Not set" : "*****"}
              {" "}
              <button
                style={{ ...profile.buttonSecondary, marginLeft: "8px", padding: "2px 6px" }}
                onClick={() => setShowToken(!showToken)}
              >
                {showToken ? "Hide Token" : "Show Token"}
              </button>
            </p>

            <button style={profile.buttonPrimary} onClick={() => openModal("token")}>
              Update BaseSpace Token
            </button>
            <button
              style={{ ...profile.buttonPrimary, marginLeft: "12px" }}
              onClick={() => openModal("password")}
            >
              Update Password
            </button>
          </div>
        </div>
      ) : (
        <p style={typography.body}>No user data</p>
      )}

      {/* Bootstrap popup modal */}
      <UpdateModal
        show={showModal}
        title={updateType === "token" ? "Update BaseSpace Token" : "Update Password"}
        fields={modalFields}
        initialValues={updateType === "token" ? { newToken: currentToken } : {}}
        onSubmit={handleUpdate}
        onClose={handleModalClose}
      />
    </MainLayout>
  );
};

export default Profile;